import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import { useTrialsContext } from 'contexts/TrialsContextProvider';

const useValidateAccount = (displayErrors = false) => {
  const { validateBusinessName } = useBusinessInfoContext() || {};
  const { hasValidLogin, hasValidName } = useTrialsContext() || {};

  return async () => {
    const validBusinessName = validateBusinessName(displayErrors);
    const validLogin = await hasValidLogin(displayErrors, true);
    const validNameFields = hasValidName();

    return validLogin && validNameFields && validBusinessName;
  };
};

export default useValidateAccount;
